import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ValidationMessageService } from '@common/services/validation-message.service';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { AbstractFormControlComponent } from './abstract-form-control.component';

@Component({
    selector: 'form-checkbox',
    styleUrls: ['form-controls.component.scss'],
    template: `
        <app-control
            [type]="'boolean'"
            [isDisabled]="isDisabled"
            [label]="labelText"
            [labelTooltip]="tooltipTitle"
            [icon]="icon"
            [ngClass]="{ 'is-invalid': isInvalid }"
            [isInvalid]="isInvalid"
            [contextual]="contextual"
            [nullableCheckbox]="nullableCheckbox"
            [(ngModel)]="value"
            (ngModelChange)="changeValue($event)"></app-control>
    `,
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckComponent extends AbstractFormControlComponent {
    @Input()
    labelText: string;
    @Input()
    tooltipTitle: string;
    @Input()
    icon: IconName;
    @Input()
    contextual: string = null;
    @Input()
    nullableCheckbox: boolean = false;

    constructor(@Self() @Optional() controlDir: NgControl, validationMessageService: ValidationMessageService) {
        super(controlDir, validationMessageService);
    }
}
